// client/src/pages/user/Referrals.js — Maxula
// P2-C (v1.158) : page Parrainage du client — code, partage WhatsApp, stats.
import React, { useEffect, useState } from 'react';
import { FiCopy, FiShare2, FiUsers, FiGift } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { referralAPI } from '../../services/api';
import Loading from '../../components/common/Loading';

const Referrals = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    referralAPI.getMine()
      .then((r) => setData(r?.data?.data || null))
      .catch(() => toast.error('Erreur de chargement'))
      .finally(() => setLoading(false));
  }, []);

  const copy = (text, label) => {
    navigator.clipboard?.writeText(text)
      .then(() => toast.success(`${label} copié !`))
      .catch(() => toast.error('Copie impossible'));
  };

  if (loading) return <Loading />;
  if (!data) return <p className="text-gray-500">Programme de parrainage indisponible.</p>;

  const shareText = `Rejoins-moi sur Maxula et profite des meilleurs deals au Maroc ! Inscris-toi avec mon lien : ${data.link}`;
  const waUrl = `https://wa.me/?text=${encodeURIComponent(shareText)}`;

  return (
    <div>
      <h1 className="text-2xl font-bold mb-1">Parrainage</h1>
      <p className="text-sm text-gray-500 mb-6">
        Invitez vos amis : dès leur premier achat, vous gagnez un code de réduction.
      </p>

      {/* Code + partage */}
      <div className="rounded-2xl border-2 border-dashed border-primary-200 bg-primary-50 p-6 text-center mb-6">
        <p className="text-xs uppercase tracking-wide text-primary-600 font-semibold mb-2">Votre code de parrainage</p>
        <p className="text-3xl font-extrabold tracking-[0.3em] text-primary-700 font-mono mb-4">{data.referralCode || '—'}</p>
        <div className="flex flex-wrap justify-center gap-3">
          <button type="button" onClick={() => copy(data.referralCode || '', 'Code')}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-white border border-primary-200 text-primary-700 text-sm font-semibold hover:bg-primary-100">
            <FiCopy size={15} /> Copier le code
          </button>
          <button type="button" onClick={() => copy(data.link || '', 'Lien')}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-white border border-primary-200 text-primary-700 text-sm font-semibold hover:bg-primary-100">
            <FiShare2 size={15} /> Copier le lien
          </button>
          <a href={waUrl} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-green-600 text-white text-sm font-semibold hover:bg-green-700">
            <FaWhatsapp size={16} /> Partager sur WhatsApp
          </a>
        </div>
      </div>

      {/* Totaux */}
      <div className="grid grid-cols-3 gap-3 mb-6">
        <div className="rounded-xl border border-gray-200 p-4 text-center">
          <FiUsers className="mx-auto text-primary-500 mb-1" />
          <div className="text-xl font-bold">{data.totals?.invited ?? 0}</div>
          <div className="text-xs text-gray-500">Invités</div>
        </div>
        <div className="rounded-xl border border-gray-200 p-4 text-center">
          <FiGift className="mx-auto text-primary-500 mb-1" />
          <div className="text-xl font-bold">{data.totals?.rewarded ?? 0}</div>
          <div className="text-xs text-gray-500">Récompensés</div>
        </div>
        <div className="rounded-xl border border-primary-200 bg-primary-50 p-4 text-center">
          <div className="text-xl font-bold text-primary-700">{Number(data.totals?.totalRewards || 0).toFixed(2)} MAD</div>
          <div className="text-xs text-primary-600">Gains cumulés</div>
        </div>
      </div>

      {/* Liste */}
      {Array.isArray(data.referrals) && data.referrals.length > 0 ? (
        <div className="overflow-x-auto rounded-xl border border-gray-200">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-600">
              <tr>
                <th className="text-left px-4 py-2.5 font-medium">Filleul</th>
                <th className="text-left px-4 py-2.5 font-medium">Date</th>
                <th className="text-left px-4 py-2.5 font-medium">Statut</th>
                <th className="text-right px-4 py-2.5 font-medium">Gain</th>
              </tr>
            </thead>
            <tbody>
              {data.referrals.map((r) => (
                <tr key={r.id} className="border-t border-gray-100">
                  <td className="px-4 py-2.5 font-medium">{r.referee}</td>
                  <td className="px-4 py-2.5 text-gray-500">{r.date ? new Date(r.date).toLocaleDateString('fr-FR') : ''}</td>
                  <td className="px-4 py-2.5">
                    <span className={`px-2.5 py-1 rounded-full text-xs font-semibold ${r.status === 'rewarded' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-800'}`}>
                      {r.status === 'rewarded' ? 'Récompensé' : 'En attente'}
                    </span>
                  </td>
                  <td className="px-4 py-2.5 text-right font-semibold">
                    {r.rewardAmount != null ? `${Number(r.rewardAmount).toFixed(2)} MAD` : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-sm text-gray-400 text-center py-6">
          Personne n'a encore utilisé votre code. Partagez-le pour commencer à gagner !
        </p>
      )}
    </div>
  );
};

export default Referrals;
